import { makeVar } from '@apollo/client'
import { GQL_ID } from '@@partner:types:graphql'
import { PartnerInfo } from '@@partner:types:app'

export const DEFAULT_PARTNER_INFO: PartnerInfo = {
  id: undefined,
  status: undefined,
  brands: [],
  assembler_id: undefined
}

export const partnerInfoVar = makeVar(DEFAULT_PARTNER_INFO)

const CURRENT_BRAND_STORAGE_KEY = 'currentBrand'

type CurrentBrandValue = { id: GQL_ID; slug: string } | undefined

const loadInitialCurrentBrand = (): CurrentBrandValue => {
  if (typeof window === 'undefined') return undefined

  try {
    const raw = window.localStorage.getItem(CURRENT_BRAND_STORAGE_KEY)
    if (!raw) return undefined

    const parsed = JSON.parse(raw)

    if (parsed && parsed.id && parsed.slug) {
      return {
        id: parsed.id as GQL_ID,
        slug: String(parsed.slug)
      }
    }

    return undefined
  }
  catch (e) {
    console.error('Failed to load currentBrand from localStorage', e)
    return undefined
  }
}

export const currentBrandVar = makeVar<CurrentBrandValue>(loadInitialCurrentBrand())

export const persistCurrentBrand = (value: CurrentBrandValue) => {
  if (typeof window === 'undefined') return

  try {
    if (!value) {
      window.localStorage.removeItem(CURRENT_BRAND_STORAGE_KEY)
      return
    }

    window.localStorage.setItem(
      CURRENT_BRAND_STORAGE_KEY,
      JSON.stringify({ id: value.id, slug: value.slug })
    )
  }
  catch (e) {
    console.error('Failed to save currentBrand to localStorage', e)
  }
}

export const sidebarExpandedVar = makeVar(false)
export const mobileMenuOpenVar = makeVar(false)
